import Repository from '@/Repository/Repository'
import { RepositoryFactory } from '@/Repository/RepositoryFactory'
const UserRepository = RepositoryFactory.get('user_repository')
import mixin from '@/mixins/global'

const state = {
    loggedUser: null,
    corporate: null
}

const getters = {
    getLoggedInUser: state => state.loggedUser,
    getCorporate: state => state.corporate
}

const actions = {
    // Login Member
    async loginMember({commit}, payload) {
        try {
            const resp = await UserRepository.loginMember(payload)
            if(resp.data.success) {
                commit("setToast", {message: resp.data.message, title: "Member Login", type: "success"})
                commit('setLoggedUser', {data: resp.data, type: 'member'})
                return 1
            }
            else {
                // commit("setToast", {message: resp.data.message, title: "Member Login", type: "danger"})
                return 0
            }
        }
        catch(err) {
            if(err.response) {
                commit("setToast", {message: err.response.data.message, title: "Corporate Login", type: "danger"})
                return 0    
            }
            commit("setToast", {message: err.message, title: "Corporate Login", type: "danger"})
            return 0
        }
    },
    
    // Login Corporate
    async loginCorporate({commit}, payload) {
        try {
            const resp = await UserRepository.loginCorporate(payload)
            if(resp.data.success) {
                commit("setToast", {message: resp.data.message, title: "Corporate Login", type: "success"})
                commit('setLoggedUser', {data: resp.data, type: 'corporate'})
                return 1
            }
            else {
                commit("setToast", {message: resp.data.message, title: "Corporate Login", type: "danger"})
                return 0
            }
        }
        catch(err) {
            if(err.response) {
                commit("setToast", {message: err.response.data.message, title: "Corporate Login", type: "danger"})
                return 0    
            }
            commit("setToast", {message: err.message, title: "Corporate Login", type: "danger"})
            return 0
        }
    },

    // New Member Registration

    async createIndividualMember({commit}, payload) {
        try {
            const resp = await UserRepository.createIndividualMember(payload)
            if(resp.data.status) {
                commit("setToast", {message: "Member Registered Successfully.", title: "Create Individual Member", type: "success"})
                return 1
            }
            if(resp.data.error) {
                return resp.data.error
            }
        } catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Create Individual Member", type: "danger"})
            return 0
        }
    },

    async getVerificationCode({commit}, payload) {
        try {
            const resp = await UserRepository.getVerificationCode(payload)
            if(resp.data.status) {
                return 1
            }
            if(resp.data.error) {
                return resp.data.error
            }
        } catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Get Verification Code", type: "danger"})
            return 0
        }
    },

    // Get Corporate
    async getCorporate({commit}, payload) {
        try {
            commit('setCorporate', null)
            const resp = await UserRepository.getCorporate(payload)
            if(resp.data.success) {
                commit('setCorporate', resp.data.member)
                return 1
            }
            else {
                commit("setToast", {message: resp.data.message, title: "Corporate Information", type: "danger"})
            }
            return 0
        } catch(err) {
            var error_message = err.message
            if ((err.response) && (err.response.data)) {
                error_message = err.response.data.message
            }
            commit("setToast", {message: error_message, title: "Corporate Information", type: "danger"})
            return 0
        }
    }
}

const mutations = {
    setCorporate: (state, payload) => {
        state.corporate = payload
    },
    setLoggedUser: (state, payload) => {
        let user = payload.data.user
        user.type = payload.type
        state.loggedUser = user

        mixin.methods.setUserToken(payload.data.token)
        localStorage.setItem('oshmiUser', JSON.stringify(user))
        Repository.defaults.headers.Authorization = `Bearer ${payload.data.token}`;
        
        // localStorage.setItem('oshmiUser', JSON.stringify(user))
        // localStorage.setItem('oshmiUserToken', JSON.stringify(payload.data.token))
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}

